import { useState, useEffect } from "react";
import { ref, onValue } from "firebase/database";
import { database } from "../config/streamFirebaseConfig";

// Live cover-music streamers, fed by liveChecker's music section.
// Node shape (keyed by VIDEO id — a channel running two concurrent
// streams appears twice):
//   musicLiveStreams/{videoId}: { videoId, title, channelId, name,
//                                 thumbnail, lastSeen }
export const useMusicStreams = () => {
  const [musicStreams, setMusicStreams] = useState({});

  useEffect(() => {
    const r = ref(database, "musicLiveStreams");
    const unsubscribe = onValue(
      r,
      (snapshot) => {
        setMusicStreams(snapshot.exists() ? snapshot.val() || {} : {});
      },
      () => {
        // On subscription error keep last-known state (mirror of the
        // checker's UNKNOWN philosophy) — don't blank the player.
      },
    );
    return () => unsubscribe();
  }, []);

  return { musicStreams };
};
